module.exports = __webpack_public_path__ + "static/media/boss-bar-yellow-09.4d65bb0c.png";